// Successful collections stay explicit; errors and unknown endpoints use objects.
export function responseShapeFor(path, method = 'GET') {
  if (method !== 'GET') return 'object';
  const route = path.split('?')[0];
  return route === 'notifications' || route === 'terms/deleted' ||
    route === 'admin/categories/history' || /^terms\/[^/]+\/history$/.test(route)
    ? 'array' : 'object';
}

// A superseded caller receives the latest request's result, including null on
// failure, so callers that continue after a refresh never receive an old state.
export function createLatestRequest({load, apply, onError = () => {}, scope = () => null}) {
  let latest;
  function invalidate() { latest = {promise: Promise.resolve(null)}; }
  function run() {
    const request = {scope: scope()};
    latest = request;
    request.promise = (async () => {
      try {
        const value = await load();
        if (latest !== request) return latest.promise;
        if (request.scope !== scope()) return null;
        apply(value);
        return value;
      } catch (error) {
        if (latest !== request) return latest.promise;
        if (request.scope !== scope()) return null;
        onError(error);
        return null;
      }
    })();
    return request.promise;
  }
  return {run, invalidate};
}
